export default __webpack_public_path__ + "static/media/booking.fad89b5a.svg";